import api from "../../../utils/api";
import { toPayload, type ScheduleForm, type ScheduledReport } from "./scheduled";

// companyId va en el query como en /reports/quick/daily: el backend lo
// respeta sólo para el administrador de plataforma (companyScope).
const params = (companyId: string) => ({ params: { companyId } });

export async function listScheduled(companyId: string, signal?: AbortSignal): Promise<ScheduledReport[]> {
  const { data } = await api.get("/reports/scheduled", { ...params(companyId), signal });
  const items = data?.items ?? data?.data?.items;
  return Array.isArray(items) ? items : [];
}

export const createScheduled = (companyId: string, input: ScheduleForm) =>
  api.post<ScheduledReport>("/reports/scheduled", toPayload(input), params(companyId)).then((r) => r.data);

export const updateScheduled = (companyId: string, id: string, input: ScheduleForm) =>
  api.put<ScheduledReport>(`/reports/scheduled/${encodeURIComponent(id)}`, toPayload(input), params(companyId)).then((r) => r.data);

export const deleteScheduled = (companyId: string, id: string) =>
  api.delete(`/reports/scheduled/${encodeURIComponent(id)}`, params(companyId)).then((r) => r.data);

export const runScheduledNow = (companyId: string, id: string) =>
  api.post(`/reports/scheduled/${encodeURIComponent(id)}/run-now`, {}, params(companyId)).then((r) => r.data);
